import React from "react";
import closeSvg from "../../../assets/svg/close.svg";

import { useAppSelector } from "store/hooks";

import { useDeleteNotification } from "hooks/useDeleteNotification";
import { useReadNotification } from "hooks/useReadNotification";
import spinnerSvg from "../../../assets/svg/spinner-white.svg";

type Props = {
  label: string;
  id: string;
  read: boolean;
};

export const NotificationListItem: React.FC<Props> = ({ label, id, read }) => {
  const navigationIsDisabled = useAppSelector(
    (state) => state.meals.navigationIsDisabled
  );
  const { mutate: deleteNotification, isLoading: deleteNotificationIsLoading } =
    useDeleteNotification();
  const { mutate: readNotification, isLoading: readNotificationIsLoading } =
    useReadNotification();

  return (
    <li
      className={`flex mb-2 lg:mr-2 h-auto rounded-md border lg:hover:bg-slate-800 cursor-pointer ${
        read
          ? "border-slate-400"
          : "border-slate-300 font-semibold bg-slate-300 bg-opacity-20"
      }`}
    >
      <div
        onClick={() => {
          if (!read && !readNotificationIsLoading && !navigationIsDisabled) {
            readNotification(id);
          }
        }}
        className="py-2 px-1 w-full"
      >
        <p className=" lg:text-xs">{label}</p>
      </div>
      <button
        disabled={
          deleteNotificationIsLoading ||
          readNotificationIsLoading ||
          navigationIsDisabled
        }
        onClick={() => {
          deleteNotification(id);
        }}
        className={`w-8 h-8 mb-20  flex justify-end`}
      >
        {deleteNotificationIsLoading && (
          <img
            className="h-6 lg:h-4 mt-1 mr-1 animate-spin"
            src={spinnerSvg}
            alt="loading"
          />
        )}
        {!deleteNotificationIsLoading && (
          <img className="h-8 lg:h-6" src={closeSvg} alt="close" />
        )}
      </button>
    </li>
  );
};
